import React from 'react'
import { Images } from "../theme"

const About = () => {
    return (
        <div className="about">
            <div className="fx fxdr fxjcc fxaic">
                <div className="w50">
                    <div className="pd15">  
                        <h1>ABOUT US</h1>
                        <p>
                        Natural Silver Solutions are the manufacturers of colloidal silver trading as <b>Karloidal Silver</b> (25ppm) registered by FDA as an antiseptic and disinfectant due to its:
                        </p>
                        <ul>    
                            <li>Antibacterial properties</li>
                            <li>Antiviral properties</li>
                            <li>Antifungal properties</li>
                        </ul>
    <p>
    In 2019, Natural Silver Solutions Ltd started in Rwanda with the aim of raising funds that will support the African child and serve those in need especially by supporting education and providing social resources to help them improve their lives through the profits made from the sales of <b>Karloidal Silver</b>.</p>
    <p>
    In Kenya over 80 students and disabled children have been supported by income from Natural Silver Solutions through a non-profit organization known as <a href="https://givinghandsnonprofit.org/" target="_blank" rel="noopener noreferrer">Giving Hands Non-Profit Organization</a>.
    </p>
                </div>
                </div>
                <div className="w50">
                    <div className="pd15">  
                        <img src={Images.scan2} alt="Scan Real Estate Ltd"/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default About
     